// lbl.home
export const home = {
    welcome_point: {
        welcome: 'ยินดีต้อนรับ',
        you_have: 'คุณมี',
        point_unit: 'แพลงก์ตอน',
        expire: 'แพลงก์ตอน หมดอายุ : ',
        my_coupon: 'สิทธิพิเศษของฉัน',
    },
    member_code: {
        fill_code: 'กรอกรหัสสำหรับสมาชิกใหม่',
        fill_time: 'กรอกภายใน : ',
        txt_minute: 'นาที',
        fill_here: 'กรอกรหัส',
        btn_confirm: 'ยืนยัน',
        code: {
            name: 'รหัส',
            placeholder: 'กรอกรหัส',
            required: '',
            too_short: '',
            invalid: '',
        },
    },
    search_placeholder: 'ค้นหาสิทธิพิเศษ',
    error_code: {
        400: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบรหัสของคุณอีกครั้ง',
        },
        404: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบรหัสของคุณอีกครั้ง',
        },
        409: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบรหัสของคุณอีกครั้ง',
        },
        2021: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบรหัสของคุณอีกครั้ง',
        },
        3002: {
            title: 'รหัสไม่ถูกต้อง',
            msg: 'โปรดตรวจสอบความถูกต้อง',
        },
        1407: {
            title: '',
            msg: 'รหัสนี้ สำหรับช่วงโปรโมชันเท่านั้น',
        },
    },
    tag_new: 'ใหม่',
    tag_popular: 'ยอดนิยม'
};
